var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgManagementGrossenTransformation21 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "model5-icon",
    viewBox: "0 0 183.22 183.22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".model5-icon .cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.22,183.22H0V0H183.22ZM3,180.22H180.22V3H3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.68,157.62H1.49l0-3c.39,0,42.94,0,53.33-20.67,30.62-61,63.63-62.16,110.48-56.95L165,80c-47-5.22-77.64-4.1-107.47,55.31C46.55,157.14,5.25,157.62,1.68,157.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.16,141.75c-8.36,0-14.39-.48-15-.53l.25-3c.39,0,39.54,3.12,59.34-6.78,8.35-4.17,27.91-13.95,39.39-39.72,16-35.81,30-59.35,50.48-66.06l.93,2.85c-19.46,6.37-33,29.37-48.67,64.43C108,119.7,87.72,129.82,79.08,134.14,66.37,140.49,46.71,141.75,33.16,141.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.67,
    y: 2.38,
    width: 3,
    height: 160.71
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgManagementGrossenTransformation21, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/management-grossen-transformation-21.2b6a575a.svg";
export { ForwardRef as ReactComponent };